export const getShuffledArray = <T>(array: Array<T>): Array<T> => {

    let shuffledArray = [...array];
    let currentIndex = array.length;

    while (currentIndex !== 0) {
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [shuffledArray[currentIndex], shuffledArray[randomIndex]]
            = [shuffledArray[randomIndex], shuffledArray[currentIndex]];
    }

    return shuffledArray;
};